interface ITransitionMeta {
	type: "jump" | "jumpState" | "default"
}
export interface TransitionData {
    destination?: string,
    trigger?: string
	meta?: ITransitionMeta
}

export class Transition {
	public readonly destination?: string;
	public readonly trigger?: string;
	public readonly meta?: ITransitionMeta;

	constructor(data: TransitionData) {
	    this.destination = data.destination;
	    this.trigger = data.trigger;
	    this.meta = data.meta;
    }

	serialise() : TransitionData {
		const serialised: TransitionData = {};

		if (this.destination !== undefined) {
            serialised.destination = this.destination;
        }
		if (this.trigger !== undefined) {
			serialised.trigger = this.trigger;
		}
		return serialised;
	};
}